/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_TitleInputs */

const en_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const fr_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

const it_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const ru_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const es_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const zh_cn2_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

const ja_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const hi_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनू`)
};

const pt_pt2_context_menu_title = /** @type {(inputs: Context_Menu_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Context_Menu_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_title = /** @type {((inputs?: Context_Menu_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_title(inputs)
	if (locale === "de") return de_context_menu_title(inputs)
	if (locale === "it") return it_context_menu_title(inputs)
	if (locale === "ru") return ru_context_menu_title(inputs)
	if (locale === "es") return es_context_menu_title(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_title(inputs)
	if (locale === "ja") return ja_context_menu_title(inputs)
	if (locale === "hi") return hi_context_menu_title(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_title(inputs)
	return en_context_menu_title(inputs)
});